module.exports = __webpack_public_path__ + "img/1658_c.f55ba48b.png";